module.exports = __webpack_public_path__ + "img/logo-secondary.e34bdf6e.png";